var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 22,
    viewBox: "0 0 11 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13778 21.3889V11.9166H10.3767L10.8656 8.22553H7.13778V5.86664C7.13778 4.80331 7.44333 4.06997 9.00778 4.06997H11V0.757751C10.6578 0.708862 9.47222 0.611084 8.09111 0.611084C5.21889 0.611084 3.25111 2.33442 3.25111 5.48775V8.21331H0V11.9044H3.25111V21.3766H7.13778V21.3889Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.cd3773830130f9e6f958c2f7d2efd731.svg";
export { ForwardRef as ReactComponent };